import { Modal, Space, message, Button } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import moment from "moment";
import store from "store";

// 近n天
export const getDate = (days) => {
  const date = new Date(Date.now() - 3600 * 1000 * 24 * days);
  const start = moment(date).format("YYYY-MM-DD") + " 00:00:00";
  const end =
    (days === 1
      ? moment(date).format("YYYY-MM-DD")
      : moment(+new Date()).format("YYYY-MM-DD")) + " 23:59:59";
  const arr = [
    moment(start, "YYYY-MM-DD HH:mm:ss"),
    moment(end, "YYYY-MM-DD HH:mm:ss"),
  ];
  return {
    start,
    end,
    arr,
  };
};

export const getDateTime = (type) => {
  let timestamp = Date.parse(new Date());
  let date = new Date(timestamp);
  date.setDate(date.getDate());
  var Y = date.getFullYear();
  var M =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  let todayDate = Y + "-" + M + "-" + D;
  return todayDate;
};

export const ranges = ({ yesterday, today, three_days, week }) => {
  let ranges = {
    昨日: null,
    今日: null,
    近三天: null,
    本周: null,
  };

  // 昨日
  const date1 = new Date(Date.now() - 3600 * 1000 * 24 * 1);
  let year1 = date1.getFullYear();
  let month1 = date1.getMonth() + 1;
  let day1 = date1.getDate();
  // 今日
  const date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  // 近三天
  const date3 = new Date(Date.now() - 3600 * 1000 * 24 * 2);
  let year3 = date3.getFullYear();
  let month3 = date3.getMonth() + 1;
  let day3 = date3.getDate();

  if (yesterday) {
    let start = year1 + "-" + month1 + "-" + day1 + " 00:00:00";
    let end = year1 + "-" + month1 + "-" + day1 + " 23:59:59";
    let arr = [
      moment(start, "YYYY-MM-DD HH:mm:ss"),
      moment(end, "YYYY-MM-DD HH:mm:ss"),
    ];
    ranges["昨日"] = arr;
  } else {
    delete ranges["昨日"];
  }
  if (today) {
    let start = year + "-" + month + "-" + day + " 00:00:00";
    let end = year + "-" + month + "-" + day + " 23:59:59";
    let arr = [
      moment(start, "YYYY-MM-DD HH:mm:ss"),
      moment(end, "YYYY-MM-DD HH:mm:ss"),
    ];
    ranges["今日"] = arr;
  } else {
    delete ranges["今日"];
  }
  if (three_days) {
    let start = year3 + "-" + month3 + "-" + day3 + " 00:00:00";
    let end = year + "-" + month + "-" + day + " 23:59:59";
    let arr = [
      moment(start, "YYYY-MM-DD HH:mm:ss"),
      moment(end, "YYYY-MM-DD HH:mm:ss"),
    ];
    ranges["近三天"] = arr;
  } else {
    delete ranges["近三天"];
  }
  if (week) {
    ranges["本周"] = [moment().startOf("week"), moment().endOf("week")];
  } else {
    delete ranges["本周"];
  }
  // console.log('ranges', ranges);
  return { ...ranges };
};

// 延迟
export const delay = (duration) =>
  new Promise((resolve) => setTimeout(resolve, duration));

export const base64ToBlob = (base64Data) => {
  const contentType = "image/jpeg";
  // 分割Base64数据和MIME类型（如果有）
  const parts = base64Data.split(";base64,");
  const decodedData = atob(parts.pop()); // 解码Base64
  const mimeType = parts?.[0]?.split(":")?.[1] || contentType; // 提取MIME类型

  // 创建Uint8Array
  const uInt8Array = new Uint8Array(decodedData.length);
  for (let i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: mimeType });
};

export const formatToTenThousand = (num, options = {}) => {
  const HundredMillion = 100000000;
  const {
    decimals = 2, // 保留小数位数，默认2位
    suffix = num >= HundredMillion ? "亿" : "万", // 单位后缀，默认'万元'
    keepSmall = false, // 小于1万时是否仍转换，默认false
    stripZeros = true, // 是否去除末尾的零，默认true
  } = options;

  const number = Number(num);
  if (isNaN(number)) return "-"; // 处理无效输入

  // 处理小于1万的情况
  if (number < 10000 && !keepSmall) {
    // return number.toLocaleString(); // 返回原始数字（带千分位）
    return number;
  }

  // 执行转换计算
  const result = (
    number / (number >= HundredMillion ? HundredMillion : 10000)
  ).toFixed(decimals);

  // 处理小数部分
  let formatted = result.toString();
  if (stripZeros) {
    formatted = formatted.replace(/\.?0+$/, ""); // 去除末尾的零和多余的小数点
  }

  return `${formatted}${suffix}`; // 拼接后缀
};


// JS正则截取字符串两字符间内容
// 示例用法
// const result = getFirstTextBetween("a1b2c3d", "a", "d");
// console.log(result); // 输出: "1b2c3"

/**
 * 截取字符串中两个指定字符之间的第一个匹配内容
 * @param {string} str 原始字符串
 * @param {string} startChar 起始字符
 * @param {string} endChar 结束字符
 * @returns {string | null} 匹配到的内容（无匹配时返回 null）
 */
export const getFirstTextBetween = (str, startChar, endChar) => {
  // 转义特殊字符（如 *、$ 等）
  const escapedStart = startChar.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const escapedEnd = endChar.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  
  // 构建正则表达式（非全局模式）
  const regex = new RegExp(`${escapedStart}(.*?)${escapedEnd}`);
  
  const match = str.match(regex);
  return match ? match[1] : null;
}

export const onPoolMsg = () => {
  const time = store.get("POOL-MSG");
  const today = moment(new Date()).format("YYYY-MM-DD");

  if (time === today) {
    message.success(
      <span>
        已加入选品池。可在
        <a href="/pool-product-list" target="_blank">
          选品池
        </a>
        页面查看
      </span>
    );
  } else {
    const modal = Modal.confirm({
      width: 480,
      icon: false,
      title: "提示",
      wrapClassName: "pool-msg-modal",
      closable: true,
      content: (
        <div className="textC">
          <div className="flex-center flex-centerY">
            <CheckCircleFilled className="success-color fz24 mr10" />
            <span>已加入选品池。可在选品池页面查看</span>
          </div>
          <Space className="mtop32">
            <Button
              type="primary"
              ghost
              onClick={() => {
                store.set("POOL-MSG", today);
                modal.destroy();
              }}
            >
              今日不再提示
            </Button>
            <Button
              type="primary"
              onClick={() => {
                modal.destroy();
                setTimeout(() => {
                  window.open("/pool-product-list");
                }, 60);
              }}
            >
              查看选品池
            </Button>
          </Space>
        </div>
      ),
      maskClosable: false,
      footer: null,
    });
  }
};
